import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';

import { InlineSVGModule } from 'ng-inline-svg-2';
import { SharedModule } from '../../../shared-module';

@Component({
  selector: 'app-statistics-card',
  templateUrl: './statistics-card.component.html',
  styleUrl: './statistics-card.component.scss',
  imports: [SharedModule],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatisticsCardComponent {
  @Input() cardTitle: string = '';
  @Input() total: string = '';
  @Input() icon: string = '';
}
